import { pedirBinario } from "@/api/cliente"

import { pdfRecibo } from "./pdfRecibo"
import { numero, type Recibo } from "./tipos"

/**
 * Compone el PDF de un recibo EMITIDO desde su foto y lo descarga. El logo de la empresa
 * de transporte se pide por la ruta autenticada de quien mira: el portal (`/transporte`)
 * o la agencia (`/agencia-transporte`). Sin logo —o si no se puede leer— sale sin él.
 */
export async function descargarRecibo(r: Recibo, base = "/api/v1/transporte"): Promise<void> {
  const foto = r.snapshot
  if (!foto) throw new Error("El recibo aún no se ha emitido")
  let logo: Uint8Array | null = null
  let mime: string | null = null
  const logoId = foto.empresa.logo_documento_id
  if (logoId) {
    try {
      const blob = await pedirBinario(`${base}/documentos/${logoId}/archivo`)
      logo = new Uint8Array(await blob.arrayBuffer())
      mime = blob.type
    } catch {
      logo = null
    }
  }
  const bytes = await pdfRecibo(foto, logo, mime, r.estado === "ANULADO")
  const url = URL.createObjectURL(new Blob([bytes as BlobPart], { type: "application/pdf" }))
  const a = document.createElement("a")
  a.href = url
  a.download = `Recibo-${numero(r.numero)}-${foto.empresa.razon_social.replace(/[^\w-]+/g, "_")}.pdf`
  a.click()
  setTimeout(() => URL.revokeObjectURL(url), 10_000)
}

export const cifra = (t: string | number | null) =>
  t === null
    ? "—"
    : Number(t).toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
